import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomFieldTypeDropdownTemplate from "@Broker/@HandlebarsTemplates/clients/board/_custom-field-type-dropdown.hbs";
import CustomFieldTypeSelectionTemplate from "@Broker/@HandlebarsTemplates/clients/board/_custom-field-type-selection.hbs";
import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2";
import CustomFieldsMixin from "@Shared/utils/board-mixins/custom-fields-mixin";
import EditCustomDropdownItems from "./edit-custom-dropdown-items";
import { capitalize, cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomField",
  components: {
    MaterialInput,
    Select2,
    EditCustomDropdownItems
  },
  mixins: [CustomFieldsMixin],
  props: {
    value: {
      type: Object,
      default: () => ({
        type: "text",
        name: ""
      })
    }
  },
  data() {
    return {
      editing: !!this.value.name
    };
  },
  computed: {
    $v() {
      return this.$parent.$v;
    },
    name: {
      get() {
        return this.value.name;
      },
      set(name) {
        this.$emit("input", _objectSpread(_objectSpread({}, this.value), {}, {
          name
        }));
      }
    },
    type: {
      get() {
        return this.value.type;
      },
      set(type) {
        this.$emit("input", _objectSpread(_objectSpread({}, this.value), {}, {
          type
        }));
      }
    },
    isDropdown() {
      return this.type === "dropdown";
    },
    options() {
      const formatResult = state => $(CustomFieldTypeDropdownTemplate(state));
      const formatSelection = state => $(CustomFieldTypeSelectionTemplate(state));
      return {
        templateResult: formatResult,
        templateSelection: formatSelection,
        dropdownParent: "#custom-fields-card",
        allowClear: false,
        escapeMarkup(markup) {
          return markup;
        }
      };
    },
    typeDefinitionsOptions() {
      return _Object$values(this.typeDefinitions);
    },
    dropdownItems() {
      var _this$value$options$i, _this$value$options;
      return (_this$value$options$i = (_this$value$options = this.value.options) == null ? void 0 : _this$value$options.items) != null ? _this$value$options$i : [];
    }
  },
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => _objectSpread(_objectSpread({}, ref), {}, {
        id: ref.key,
        text: capitalize(ref.text)
      }));
    },
    handleSelectChange({
      id
    }) {
      this.type = id;
    },
    handleDropdownInput(value) {
      this.$emit("update-dropdown-value", value);
    },
    handleEditing(editing) {
      this.$emit("editing", editing);
    }
  }
});